import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()

export class ModalService {
    public isSubmit = new Subject<boolean>();
    // public isSubmit = false;
    public modals: any[];

    constructor(){
        if (!this.modals) {
            this.modals = [];
        }
    }


    add(modal: any) {
        // add modal to array of active modals
        this.modals.push(modal);
    }

    remove(id: string) {
        // remove modal from array of active modals
        this.modals = this.modals.filter(x => x.id !== id);
    }

    open(id: string) {
        // open modal specified by id
        const modal: any = this.modals.filter(x => x.id === id)[0];
        if (modal) {
            modal.open();
        }
    }

    close(id: string) {
        // close modal specified by id
        const modal: any = this.modals.filter(x => x.id === id)[0];
        if (modal) {
            modal.close();
        }
    }

    confirm(): Promise<boolean> {
        this.open('confirmation-modal');
        return new Promise((resolve) => {
            const a = this.isSubmit.subscribe((data) => {
                if (data) {
                    resolve(true);
                }
                a.unsubscribe();
            });
        });
    }
}
